// extracted by mini-css-extract-plugin
module.exports = {"root":"Container-module__root___rVjIb","root--full-width":"Container-module__root--full-width___8PpvH"};